<template>
  <ClientOnly>
		<div class="video__container">
			<iframe v-if="videoId !== null"
							width="560"
							height="315"
							class="lazyload video"
							loading="lazy"
							:src="`https://www.youtube.com/embed/${videoId}`"
							:title="videoTitle"
							frameborder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowfullscreen>
			</iframe>
		</div>
  </ClientOnly>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n, useLocalePath } from '#imports'
const { locale } = useI18n()
const props = defineProps({
  content: Object
})
const looping = computed(() => props.content.isLooping ? '1' : '0' )
const autoplay = computed(() => props.content.isAutoplay ? '0&playsinline=0&muted=0' : '1&playsinline=1&&muted=1' )
const controls = computed(() => props.content.hasControls ? '0' : '1' )
let videoTitle
if (props.content.title != null) {
	videoTitle = computed(() => locale.value === 'en' ? props.content.title.en : props.content.title.jp)
}
let videoId
if (props.content.video != null) {
	videoId = computed(() => locale.value === 'en' ? props.content.video.en : props.content.video.jp)
}
</script>

<style lang="scss" scoped>
	.video {
		width: 100%;
	}
	.video__container {
		margin: 0;
	}
</style>
